<template>
  <div class="like" :class="getLikeStyle" @click.prevent="like"></div>
</template>

<script>
export default {
  props: {
    id: Number,
    liked: Number,
    likeCount: Number,
    contentType: Number,
    likeStyle: {
      type: String,
      default: ''
    },
    auth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getLikeCount() {
      return this.$store.getters['like/getLikeCount'];
    },
    getLiked() {
      return this.$store.getters['like/getLiked'];
    },
    getLikeStyle() {
      const liked = (this._liked === 1) ? ' liked' : '';
      return this.likeStyle + liked;
    }
  },
  data: () => ({
    _liked: 0,
    _like_count: 0,
    changing: false,
    types: [
      {1: 'shop'},
      {2: 'article'},
      {3: 'movie'},
      {4: 'gift'},
      {5: 'coupon'}
    ]
  }),
  mounted() {
    if (this.auth) {
      this._liked = this.liked;
    } else {
      this._liked = (this.checkLikeLocalStorage()) ? 1 : 0;
    }
    this._like_count = this.likeCount;
  },
  watch: {
    getLiked(likedList) {
      if (likedList[this.contentType] != undefined &&
        likedList[this.contentType][this.id] != undefined &&
        this._liked != likedList[this.contentType][this.id]
      ) {
        this._liked = likedList[this.contentType][this.id];
      }
    },
    getLikeCount(likeCountList) {
      if (likeCountList[this.contentType] != undefined &&
        likeCountList[this.contentType][this.id] != undefined &&
        this._like_count != likeCountList[this.contentType][this.id]
      ) {
        this._like_count = likeCountList[this.contentType][this.id];
      }
    }
  },
  methods: {
    like() {
      if (!this.auth) {
        // 非ログインの場合、snackbarを表示
        this.$store.dispatch('like/setSignupAppeal', true);
        // LocalStorageに保存
        this.setLikeLocalStorage()
      }
      if (!this.changing) {
        this.changing = true;
        let url;
        if (this._liked == 0) {
          url = '/api/users/like/add'; // お気に入り
          this._liked = 1;
          this._like_count += 1;
        } else {
          url = '/api/users/like/delete'; // お気に入り解除
          this._liked = 0;
          this._like_count -= 1;
        }
        this.$axios.post(url, {
          content_id: this.id,
          content_type: this.contentType
        })
        .then(() => {
          // お気に入り数を他コンポーネントに伝達
          const likeCounts = this.$_.cloneDeep(this.getLikeCount);
          likeCounts[this.contentType][this.id] = this._like_count;
          this.$store.dispatch('like/setLikeCount', likeCounts);

          // お気に入りしたか否かを他コンポーネントに伝達
          const liked = this.$_.cloneDeep(this.getLiked);
          liked[this.contentType][this.id] = this._liked;
          this.$store.dispatch('like/setLiked', liked);
        })
        .catch( (error) => {
          if (this._liked == 0) {
            this._liked = 1;
            this._like_count -= 1;
          } else {
            this._liked = 0;
            this._like_count += 1;
          }
        })
        .finally(() => {
          this.changing = false;
        });
      }
    },
    getLikeLocalStorage() {
      // コンテンツ名を取得
      const foundObj = this.types.find(obj => obj[this.contentType])
      if (foundObj) {
        let itemName = foundObj[this.contentType] + 'Like'
        let itemLike = localStorage.getItem(itemName)
        if (itemLike) {
          // データが存在する場合、JSONパースして配列に変換
          itemLike = JSON.parse(itemLike)
        } else {
          itemLike = []
        }
        const index = itemLike.indexOf(this.id)

        return {
          itemName: itemName,
          itemLike: itemLike,
          index: index
        }
      }
    },
    checkLikeLocalStorage() {
      const res = this.getLikeLocalStorage()
      return res.index !== -1
    },
    setLikeLocalStorage() {
      const res = this.getLikeLocalStorage()
      if (res.index !== -1) {
        // IDが存在する場合は削除
        res.itemLike.splice(res.index, 1)
      } else {
        res.itemLike.unshift(this.id)
      }
      // todo 上限50?
      res.itemLike.splice(50)
      localStorage.setItem(res.itemName, JSON.stringify(res.itemLike))
    }
  }
}
</script>

<style lang="scss">
  .like{
    cursor: pointer;
    z-index: 3;
    &.liked {
      background: url(/assets/img/common/heart.svg) center center/contain no-repeat !important;
    }
  }
</style>
